import { IWho, WhoHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

/**rhybusWhoHttp:
 * Who - Access information about yourself and others.
 */
export const rhybusWhoHttp = (): IWho => {
  try {
    return new WhoHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint WhoHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)
    throw error
  }
}
